import { render } from "./App.vue?vue&type=template&id=ab53d104"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ab53d104&lang=scss"

import exportComponent from "D:\\workarea\\example\\景区旅游\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__